import { render, staticRenderFns } from "./SectionsDisplay.vue?vue&type=template&id=22bf1f96&"
import script from "./SectionsDisplay.vue?vue&type=script&lang=js&"
export * from "./SectionsDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports